/** @format */

export enum SEARCH_LOCATION {
  CART,
  PDP,
  BUNDLE,
}
